/* eslint-disable import/prefer-default-export */
import MetricTimeUnit, { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import { createMetric } from 'utils/runSearchUtil'
import { getMetricSeries } from 'utils/measureTypeUtil'
import { Dashboard } from 'schemas/DashboardSchema'
import { Filter } from 'schemas/FilterSchema'
import { MeasureTypeStrings } from 'enums/MeasureType'
import { RunSearch } from 'schemas/action/RunSearchSchema'
import { getSparklineMetricTimeUnit } from 'utils/sparklineMetricTimeUnit'
import { TopicComparisonWidgetType } from '../../types'
import { NUMBER_MEASURES, TREND_MEASURES } from './constants'

export const createSearches = (
  widgetSetting: TopicComparisonWidgetType,
  dashboardData: Dashboard,
  filter: Filter,
  isAudienceQuery: boolean
) => {
  const { precision } = widgetSetting
  const { id: dashboardId, name: dashboardName } = dashboardData
  const createSearch = (
    topicId: number,
    measures: Array<MeasureTypeStrings>,
    timeUnits: Array<MetricTimeUnitStrings>
  ): RunSearch =>
    createMetric(
      dashboardId!,
      dashboardName!,
      precision!,
      [topicId],
      filter,
      measures.flatMap(getMetricSeries),
      timeUnits,
      { isAudienceQuery }
    )

  const sparklineMetricTimeUnit = getSparklineMetricTimeUnit(filter.publishedDate)

  return widgetSetting.topicInfos!.flatMap(({ topicId }) => {
    const measuresSearch = createSearch(topicId!, NUMBER_MEASURES, [MetricTimeUnit.ALL])
    const trendSearch = createSearch(topicId!, TREND_MEASURES, [sparklineMetricTimeUnit])
    return [measuresSearch, trendSearch]
  })
}
